import React, { useEffect, useState } from 'react';
import { getPublicSiteMarketingConfig } from '../utils/publicSiteConfig';

function SiteEntry() {
  const [message, setMessage] = useState('Loading…');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { marketingSiteBaseUrl } = await getPublicSiteMarketingConfig();
        if (cancelled) return;
        window.location.replace(marketingSiteBaseUrl);
      } catch {
        if (!cancelled) setMessage('Could not load site configuration.');
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div style={{ padding: '2rem', fontFamily: 'system-ui, sans-serif', textAlign: 'center' }}>
      <p>{message}</p>
    </div>
  );
}

export default SiteEntry;
